<h2 mat-dialog-title>METAR and TAF values are color-coded based on the following criteria:</h2>

<mat-dialog-content>
  <p>The following color-code assignments are used in AOPA METAR and TAF presentations. METAR and TAF data is sourced
    primarily from the NOAA AWS (Aviation Weather Center). AOPA augments this data with range/value color-coding and
    standard abbreviation translations.</p>
  <ul>
    <li>Wind (including gusts):
      <ul>
        <li><span style="color: orange">Orange</span> when >= 20 knots</li>
        <li><span style="color: red">Red</span> when >= 30 knots</li>
      </ul>
    </li>
    <li>Visibility:
      <ul>
        <li><span style="color: orange">Orange</span> when <= 5 sm or when there is a runway visual range</li>
        <li><span style="color: red">Red</span> when <= 1 sm or when the runway visual range is less than 1,800 ft</li>
      </ul>
    </li>
    <li>Ceiling (including any layers that would count as a ceiling, or vertical visibility):
      <ul>
        <li><span style="color: orange">Orange</span> when <= 2,000 ft</li>
        <li><span style="color: red">Red</span> when <= 1,000 ft or when cumulonimbus clouds</li>
      </ul>
    </li>
    <li>Weather:
      <ul>
        <li><span style="color: orange">Orange</span> for Mist, Unknown Precip, Blowing Dust, Blowing Snow, any precip
          that is heavier than light (but not upgraded to red, like any freezing precip), any form of non-freezing
          Showers (like Rain Showers)</li>
        <li><span style="color: red">Red</span> for Thunderstorm, Any type of freezing precip, Fog, Smoke, Volcanic
          Ash, Dust, Sand, Dust/Sand Whirls, Squalls, Funnel Cloud, Sandstorm, Duststorm</li>
      </ul>
    </li>
    <li>Wind Shear:
      <ul>
        <li><span style="color: red">Red</span> for any wind shear</li>
      </ul>
    </li>
    <li>Turbulence:
      <ul>
        <li><span style="color: orange">Orange</span> for light turbulence</li>
        <li><span style="color: red">Red</span> for all other turbulence</li>
      </ul>
    </li>
    <li>Icing:
      <ul>
        <li><span style="color: orange">Orange</span> for all forms of light icing (though not Trace Icing)</li>
        <li><span style="color: red">Red</span> for all moderate types of icing and above</li>
      </ul>
    </li>
    <li>Remarks (when properly formatted):
      <ul>
        <li><span style="color: orange">Orange</span> for towering cumulus, wet runway</li>
        <li><span style="color: red">Red</span> for cumulonimbus, ice on runway, lightning, loose snow on runway,
          packed snow on runway, hail, snow increasing rapidly, volcano, tornado, funnel cloud, waterspout</li>
      </ul>
    </li>
  </ul>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close class="aopa-mat-btn aopa-mat-btn--outlined" (click)="close()">Close</button>
</mat-dialog-actions>
